import { GiftDetailInfoByGiftIdxSpace } from 'src/types/api'
import React, { useEffect } from 'react'
import { Loading } from 'src/components/common/Loading'
import RenderIf from 'src/components/common/RenderIf'
import { QueryClient } from '@tanstack/react-query'
import { Params } from 'react-router-dom'
import useParamsType, { MatchParams } from 'src/hooks/useParamsType.hook'
import {
  giftDetailInfoByGiftIdxQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import GiftReceivePage from 'src/pages/GiftCardPage/GiftReceivePage'
import GiftReceiveResultPage from 'src/pages/GiftCardPage/GiftReceiveResultPage'
import Modal from 'src/components/common/Modal'
import { useModal } from 'src/provider/ModalContextProvider'

export const giftCardPageLoader =
  (queryClient: QueryClient) =>
  async ({
    params: { giftIdx },
    request,
  }: {
    params: Params<keyof MatchParams>
    request: Request
  }) => {
    return Promise.allSettled([
      await queryClient.ensureQueryData(
        giftDetailInfoByGiftIdxQueryOption({ GiftIdx: Number(giftIdx), GiftURL: request.url }),
      ),
    ])
  }

export interface GiftCardPageProps {
  giftDetailData: GiftDetailInfoByGiftIdxSpace.Response
}

const GiftCardPage = () => {
  const { giftIdx } = useParamsType()
  const { isOpen: modalOpen } = useModal()

  const { data: giftDetailByGiftIdxQueryData, isLoading: isGiftDetailByGiftIdxLoading } =
    useCustomQuery<GiftDetailInfoByGiftIdxSpace.Response>(
      giftDetailInfoByGiftIdxQueryOption({
        GiftIdx: Number(giftIdx),
        GiftURL: window.location.href,
      }),
    )

  const { GiftStatus } = giftDetailByGiftIdxQueryData?.Body!
  const isGiftWating = GiftStatus === 0

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [GiftStatus])

  const props: GiftCardPageProps = { giftDetailData: giftDetailByGiftIdxQueryData?.Body! }

  return (
    <React.Fragment>
      <RenderIf when={modalOpen}>
        <Modal />
      </RenderIf>
      <RenderIf when={isGiftDetailByGiftIdxLoading}>
        <Loading.Default />
      </RenderIf>
      <RenderIf when={isGiftWating}>
        <GiftReceivePage {...props} />
      </RenderIf>
      <RenderIf when={!isGiftWating}>
        <GiftReceiveResultPage {...props} />
      </RenderIf>
    </React.Fragment>
  )
}
export default GiftCardPage
